module.exports = __webpack_public_path__ + "img/about3.1a3534b9.png";